<div *ngIf="ownerUser" class="d-flex align-items-center cursor-pointer" [routerLink]="['/account/' + ownerUser.name]" (click)="$event.stopPropagation();">
  <!-- <div class="img-nft-profile active-nft-profile active-nft-profile-header aura-effect-header image-profile-preview">
    <img class="avatar-xs rounded-circle" src="https://ipfs.bitkubnext.io/ipfs/QmVBuDLnnpEv44UoGKWKwcm2EJYjkngqFeQRDZkSu2Fn4Z" alt="">
  </div> -->

  <div *ngIf="nftProfile" class="img-nft-profile active-nft-profile active-nft-profile-header image-profile-preview {{nftProfile.image ? 'aura-effect-header':'image-profile-general'}} ">
    <img class="avatar-xs rounded-circle" [src]="(nftProfile.image | renderImageUrl: 'logo')" alt="">
  </div>
</div>
